import BasicTopicList from "discourse/components/basic-topic-list";
import ConditionalLoadingSpinner from "discourse/components/conditional-loading-spinner";
import LoadMore from "discourse/components/load-more";
import PluginOutlet from "discourse/components/plugin-outlet";
import lazyHash from "discourse/helpers/lazy-hash";
import { or } from "discourse/truth-helpers";
import { i18n } from "discourse-i18n";

const CircleActivityTopics = <template>
  <PluginOutlet
    @name="circles-activity-topics"
    @outletArgs={{lazyHash circleModel=@controller.circleModel model=@model}}
  >
    {{#if @controller.circleModel.can_read_topics}}
      <div class="circles-activity-topics-wrapper">
        <PluginOutlet
          @name="circles-activity-topics-paginated-list"
          @outletArgs={{lazyHash
            circleModel=@controller.circleModel
            model=@model
          }}
        >
          <LoadMore
            @action={{@controller.loadMore}}
            @selector=".paginated-topics-list .topic-list tr"
            class="paginated-topics-list"
          >
            {{#if (or @model.topics @controller.loadingMore)}}
              <BasicTopicList @topicList={{@model}} @showPosters={{true}} />
              <ConditionalLoadingSpinner @condition={{@model.loadingMore}} />
            {{else}}
              <div class="alert alert-info alert-no-topics">
                {{i18n "discourse_circles.circle.no_topics"}}
              </div>
            {{/if}}
          </LoadMore>
        </PluginOutlet>
      </div>
    {{else if @controller.circleModel.isPublic}}
      {{i18n "discourse_circles.circle.activity.cant_read_public"}}
    {{else if @controller.circleModel.isPrivate}}
      {{i18n "discourse_circles.circle.activity.cant_read_private"}}
    {{else}}
      {{i18n "discourse_circles.circle.activity.cant_read_other"}}
    {{/if}}
  </PluginOutlet>
</template>;

export default CircleActivityTopics;
